import React from 'react';
import { Checkbox } from '@mantine/core';
import useUpdateCheckList from '../hooks/useUpdateChecklist';

export default function SingleCheckListOnTask({ singleitem, item1 }) {
  const updateChecklistMutation = useUpdateCheckList(item1?.id);

  return (
    <div className='flex items-center space-x-2 mt-2' key={singleitem?.id}>
      <Checkbox
        checked={singleitem?.is_completed}
        onChange={(e) => {
          updateChecklistMutation.mutate({
            id: singleitem?.id,
            task_id: item1?.id,
            is_completed: e.currentTarget.checked,
          });
        }}
        classNames={{
          input: 'rounded-full cursor-pointer',
        }}
      />
      <p className='text-sm text-gray3'>{singleitem?.checklist}</p>
    </div>
  );
}
